import uuid from 'uuid'

// Computes the next sort state for a column. If the column is already the
// active sort, its direction is toggled; otherwise a fresh descending sort is
// started. Shared by DataTable.vue and ReferralsList.vue to keep their
// initSort logic identical without duplicating the block.
export const getNextSort = function (currentSort, column) {
  const sortProp = column.sortProp || column.prop
  if (currentSort && currentSort.prop === sortProp) {
    return {
      ...currentSort,
      key: uuid.v4(),
      direction: currentSort.direction === 'desc' ? 'asc' : 'desc',
    }
  }
  return {
    key: uuid.v4(),
    id: column._t_id,
    prop: sortProp,
    direction: 'desc',
  }
}

export const sort = function () {
  let arrayOfSort = []
  let esSort = {}
  const get = function () {
    return arrayOfSort
  }

  const formatProp = function (p = '') {
    return p.replace(/\//g, '.')
  }

  const add = function (sortItem) {
    const prop = formatProp(sortItem.prop)
    if (typeof prop === 'undefined' || !prop) {
      return
    }
    arrayOfSort = []
    arrayOfSort.push(['sort[0][field]', formatProp(sortItem.prop)])
    arrayOfSort.push(['sort[0][dir]', sortItem.direction])
    esSort = [
      {
        [prop]: {
          order: sortItem.direction,
        },
      },
    ]
  }

  const set = function (sortList) {
    arrayOfSort = sortList
  }

  const asQueryParams = function () {
    return arrayOfSort
      .filter((f) => f[0] !== null)
      .map((f) => `${f[0]}=${f[1]}`)
      .join('&')
  }

  const asESSort = function () {
    return esSort
  }

  return {
    get,
    set,
    add,
    asESSort,
    asQueryParams,
  }
}
